import { SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CommonFieldName, CommonFieldLabel } from "@app/shared/constants";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";

export enum ReportLinkFieldName {
  reportName = "reportName",
  reportUrl = "reportUrl",
  description = "description",
  country = "country",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  reportLink_Id = "reportLink_Id"
};

enum FieldLabel {
  REPORT_NAME = "ml_144101",
  LINK = "ml_144102",
  DESCRIPTION = "ml_143964",
  COUNTRY = "ml_143912",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919"
}

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.REPORT_NAME,
    name: ReportLinkFieldName.reportName,
    sort: true
  },
  {
    text: FieldLabel.LINK,
    name: ReportLinkFieldName.reportUrl,
    sort: false
  },
  {
    text: FieldLabel.DESCRIPTION,
    name: ReportLinkFieldName.description,
    sort: false
  },
  {
    text: FieldLabel.COUNTRY,
    name: ReportLinkFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.CREATED_BY,
    name: ReportLinkFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: ReportLinkFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: ReportLinkFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: ReportLinkFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
]

const ReportLinkSearchByList: SearchByItem[] = [
  { searchBy: ReportLinkFieldName.reportName, searchByLabel: FieldLabel.REPORT_NAME },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const GetReportLinkSearchByList = () => {
  return ReportLinkSearchByList.slice();
}
